import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import ChartTypes from "@/components/ChartTypes.tsx";
import DashboardDataGenerator from "../../DashboardDataGenerator";
import ReadingOverall from "./ReadingOverall";
import ReadingSkill from "./ReadingSkill";

@Component
export default class SkillsDashboard extends Vue {
  private processedData: any;
  private overallData: any;
  private data: any;
  private studentData: any;

  constructor() {
    super();
    this.overallData = {};
    this.processedData = {};
    this.studentData = this.$store.getters.studentData;
    this.data = this.$store.getters.teacherDashboard.bala.timepoint1.results;
  }

  private getAllData() {
    // all state should be loaded by now

    // overall data is the averages data.
    let averagesData = this.$store.getters.teacherDashboard.bala.timepoint1
      .averages;

    averagesData &&
      Object.keys(averagesData).forEach(key => {
        this.overallData[key] = averagesData[key];
      });

    let skillsDashboards = ["discourse", "explicit", "inferencing"]; // from firestore don't change
    let dashboards = this.$store.getters.teacherDashboard.bala.descriptions
      .dashboards;

    this.overallData.selection = "overall"; // selecting which overall dashboard;

    skillsDashboards.forEach(key => {
      this.processedData[key] = {};
      this.processedData[key]["students"] = {};
      this.processedData[key]["mean"] = this.overallData[key];
      this.processedData[key]["label"] = dashboards[key].name;
      this.processedData[key]["color"] = dashboards[key].color;
    });

    this.data &&
      Object.keys(this.data).forEach(key => {
        let name = this.studentData[key].firstname;
        let data = this.data[key];

        skillsDashboards.forEach(key => {
          this.processedData[key]["students"][name] = {
            percent: data[key]["proportion"] * 100
          };
        });
        // this.overallData[name] = {percent: this.data[key]['overall']['proportion']}
      });

    return true;
  }

  private dashboardUnavailable() {
    return (
      <v-container>
        <v-row>There's not enough data to generate a dashboard.</v-row>
      </v-container>
    );
  }

  private stateLoaded() {
    return (
      this.$store.getters.studentDataLoaded &&
      this.$store.getters.teacherDashboard.bala.timepoint1Loaded &&
      this.$store.getters.teacherDashboard.bala.descriptionsLoaded
    );
  }

  render(h: CreateElement) {
    return (
      (this.stateLoaded() && this.getAllData() && (
        <v-container style={{ padding: "24px" }}>
          <v-row>
            <v-col cols="6">
              <ReadingSkill data={this.processedData["explicit"]} />
            </v-col>
            <v-col cols="6">
              <ReadingSkill data={this.processedData["inferencing"]} />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <ReadingSkill data={this.processedData["discourse"]} />
            </v-col>
            <v-col cols="6">
              <ReadingOverall data={this.overallData} />
            </v-col>
          </v-row>
        </v-container>
      )) ||
      this.dashboardUnavailable()
    );
  }
}

const component = SkillsDashboard;
